module.exports = __webpack_public_path__ + "static/media/getPlayStore.cf4f3cdd.svg";